import { useState, useEffect } from 'react';
import { api } from '../services/api';
import type { Problem } from '@attack100/shared';

export function useProblems() {
  const [problems, setProblems] = useState<Problem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProblems = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.getProblems();
      setProblems(data.problems);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch problems');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProblems();
  }, []);

  return { problems, loading, error, refetch: fetchProblems };
}
